export class JsonUtils {
  public static isEmpty(json: any) {
    if (Array.isArray(json)) {
      throw new Error('json passed is an array');
    } else {
      const keys = Object.keys(json || {});
      return keys.length <= 0;
    }
  }
}
